export function formatSituation(value: string) {
    const situationType = value.substring(0, 3);

    return situationType === '349' ? 'Débito' : 'Crédito';
}

export function formatLocationPath(value: string) {
    const parts = value.split('/');
    const regexDetalhesPeriodo = /(\d{4}-\d{2}-\d{2})\/(\d{4}-\d{2}-\d{2})/;
    const regexDetalhesFerias = /(\d{4}-\d{2}-\d{2})\/(\d{4}-\d{2}-\d{2})\/(\d+)\/(\d+)\/([A-Z])\/([A-Za-z]+)/;

    let newPath = value;

    if (parts.length >= 6 && parts.length < 9) {
        newPath = value.replace(regexDetalhesPeriodo, ':inicioPeriodo/:fimPeriodo');
    } else if (parts.length >= 10) {
        newPath = value.replace(regexDetalhesFerias, ':inicioPeriodo/:inicioFerias/:diasProgramados/:diasAbono/:adiantamento13/:descricaoStatus');
    }

    return newPath;
}
